module.exports = __webpack_public_path__ + "img/logo_capital_partners_alt.19201d01.svg";